 <!-- 我的报名 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的考试</p>
      </div>
      <!-- <div>
        <el-button :class="cur==1?'':'buttons'" size="small" :type="cur==1?'warning':''" round @click="onButton(1)">正式考试</el-button>
        <el-button :class="cur==2?'':'buttons'" size="small" :type="cur==2?'warning':''" round @click="onButton(2)">练习考试</el-button>
      </div> -->
    </div>
    <div class="nav-list" v-if="cur==1">
      <ul>
        <!-- <li class="type" :class="type==0?'cur':''" @click="onCur(0)">未开考</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==1?'cur':''" @click="onCur(1)">待考试</li> -->
        <li class="type" :class="type==0?'cur':''" @click="onCur(0)">全部</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==2?'cur':''" @click="onCur(2)">待批改</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==3?'cur':''" @click="onCur(3)">已完成</li>
      </ul>
    </div>
    <div class="enroll-list">
      <ul>
        <li v-for="item,index in examItem" :key="index">
          <div class="img">
            <img :src="item.examImg">
          </div>
          <div class="contetn">
            <div class="contetn-top" style="padding-top: 0;">
              <p class="title">{{item.examName}}</p>
              <span v-if="cur==1">
                <div v-if="item.status==0 || item.status==1" style="display: flex;align-items: center;">
                  <p style="font-size: 13px;color: #8f8f8f;  margin-right: 10px;" >开考时间：{{item.startTime}}</p>
                  <p class="type" v-if="item.status==0">未开考</p>
                  <p class="type" v-else-if="item.status==1">待考试</p>
                </div>
                <p class="type" v-else-if="item.status==2">待批改</p>
                <p class="type" v-else-if="item.status==3">已完成</p>
              </span>
              
            </div>
            <div class="contetn-kv">
              <p class="key">题目：<span>{{item.questionCount}}道</span></p>
              <p class="key">总分：<span>{{item.totalScore}}分</span></p>
              <p class="key" style="width: auto;">通过分数：<span>{{item.passScore}}分</span></p>
              <p class="key">允许考试次数：<span>{{item.examCount}}次</span></p>
              <p class="key" >限制时长：<span>{{item.examDuration}}分钟</span></p>
            </div>
            <div style="display: flex;align-items: center;justify-content: flex-start; position: relative;" v-if="cur==1">
              
              
              <!-- 正式考试 -->
              <div style="margin-left: 10px;">
                <el-button size="small" type="info" disabled v-if="item.status==0">开始考试</el-button>
                <el-button class="buttonss"  size="small" type="small" v-if="item.status==1" @click="onExamPage(item.id,0)">开始考试</el-button>
              </div>
             
              <div v-if="item.status==3" style="display: flex;align-items: center;justify-content: flex-start;">
                <p class="types">成绩：{{item.memberScore?item.memberScore:0}}分</p>
                <el-button class="buttons" size="small">{{item.resultStatus==0?'已审批':(item.resultStatus==1?'已通过':'未通过')}}</el-button>
                <el-button style="background-color: #ff821c" size="small" type="warning" @click="examResult(item.id,0)">查看成绩</el-button>
              </div>

              <!-- 重新预约 -->
              <div style="margin-left: 10px;" v-if="item.status==0 || item.status==3">
                <el-button style="background-color: #ff821c" size="small" type="warning" v-if="item.appointmentStatus==1"
                  @click="onAnew(item.startTime,item.id,item.examId)">重新预约</el-button>
                <el-button size="small" type="info" disabled v-if="item.appointmentStatus!=1">重新预约</el-button>
              </div>

              <!-- 模拟考试 -->
              <div v-if="item.status==0" style="display: flex; margin-right: 10px; position: absolute; right: 0;">
                <el-button size="small" type="info" disabled v-if="item.ifPractice!=1">模拟考试</el-button>
                <div v-if="item.ifPractice==1">
                  <el-button class="buttonss" size="small" type="small" @click="onExamPage(item.id,1)">模拟考试</el-button>
                  <el-button class="buttonss" size="small" type="small" @click="onResetPractice(item.id)" style="margin-left: 4px;">重新抽题</el-button>
                </div>
                <el-button v-if="item.resultStatusPractice>0" style="background-color: #ff821c;margin-left: 10px;" size="small" type="warning" @click="examResult(item.id,1)">查看成绩</el-button>
              </div>
            </div>
            <!-- <div  v-else>
              <el-button style="background-color: #ff821c" size="small" type="warning" @click="onExamPage(item.id,0)">进入考试</el-button>
              <el-button style="background-color: #ff821c" size="small" type="warning" @click="examResult(item.id,item.ifPractice)" v-if="item.status==3">查看解析</el-button>
            </div> -->
          </div>
        </li>
      </ul>
    </div>
    <!-- <el-pagination
      background
      layout="prev, pager, next"
      :total="100">
    </el-pagination> -->

    <div class="popup">
      <!-- 成绩查看 -->
      <el-dialog title="" :visible.sync="dialogFormVisible">
        <p class="popup-title">成绩查看</p>
        <div class="popup-form">
          <div class="popup-form-coupon">
            <el-table
              :data="tableData"
              :show-header="false"
              border
              style="width: 100%">
              <el-table-column
                prop="name"
                width="150">
              </el-table-column>
              <el-table-column
                prop="date">
              </el-table-column>
            </el-table>
          </div>
          <div style="display: flex;align-items: center;justify-content:center;margin: 50px 0 40px;" v-if="ifPractice==1">
            <!-- <el-button style="background-color: #ff821c" size="medium" type="warning" @click="dialogFormVisible1 = false" style="width: 200px;">确定</el-button> -->
            <el-button  size="medium" type="warning" @click="onAnalysis" style="width: 200px;background-color: #ff821c" >查看解析</el-button>
          </div>
        </div>
      </el-dialog>

      <el-dialog title="" :visible.sync="dialogFormVisible2">
        <p class="popup-title">重新预约</p>
        <div class="popup-form">
          <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-form-item label="原考试时间">
              <p>{{form.startTime}}</p>
            </el-form-item>
            <el-form-item label="重新预约考试时间" prop="region">
              <el-select v-model="form.region" filterable placeholder="请选择考试场次" style="width: 100%" @change="onCollege">
                <el-option
                  style="font-size: 12px;"
                  v-for="item in collegeList"
                  :key="item.id"
                  :label="item.startTime"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="buttons" size="medium" @click="dialogFormVisible2 = false" style="width: 100px">取 消</el-button>
            <el-button size="medium" type="warning" :loading="loadings" @click="getChangeLot('ruleForm')" style="width: 100px;background-color: #ff821c">提 交</el-button>
          </div>
        </div>
        
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mySignRecord,getExamResult,lotList,changeLot,resetPractice} from '../../api/userMG'
export default {
  data() {
    return {
      dialogFormVisible:false,
      dialogFormVisible2:false,
      cur:1,
      type:0,
      page:1,
      rows:16,
      total:0,
      examItem:[],
      signId:'',
      ifPractice:0,
      tableData: [{
        name: '开始时间',
        date: '2016-05-02',
      }, {
        name: '交卷时间',
        date: '2016-05-04',
      }, {
        name: '成绩分数',
        date: '115分',
      }, {
        name: '通过分数',
        date: '100分',
      }, {
        name: '考试结果',
        date: '通过',
      }],
      collegeList:[],
      lotId:'',
      form:{
        id:'',
        startTime:'',
        region:''
      },
      rules: {
        region: [
          { required: true, message: '请选择考试场次', trigger: 'change' }
        ],
      },
      loadings:false,
      loadingr:false
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  
  created() {
    // if(this.$route.query){
    //   this.type = this.$route.query.key;
    // }
    this.getMySignRecord();
  },
  methods:{
    onAnew(startTime,id,examId){
      this.form.startTime = startTime;
      this.form.id = id;
      this.examId = examId;
      this.dialogFormVisible2 = true;
      this.getLotList();
    },

    // 获取考试轮次列表
    getLotList(){
      let params = {
        examId:this.examId
      }
      lotList(params).then(res => {
        console.log('考试轮次列表',res);
        this.collegeList = res.data;
      })
      .catch(err => {
      })
    },

    onCollege(id){
      console.log("选中学校id",id)
      this.lotId = id
    },

    // 重新预约
    getChangeLot(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            signId:this.form.id,
            lotId:this.lotId
          }
          changeLot(params).then(res => {
            if(res.code==0){
              this.$message({
                type: 'success',
                message: '报名成功',
                offset:100
              });  
              this.dialogFormVisible2 = false;
              this.getMySignRecord();
            }
            this.loadings = false;
          }).catch(err => {
            this.loadings = false;
            this.dialogFormVisible2 = false;
          })
        }
      })
    },

    onResetPractice(id){
      let params = {
        signId:id
      }
      resetPractice(params).then(res => {
        if(res.code==0){
          this.$message({
            type: 'success',
            message: '重新抽题成功',
            offset:100
          });
        }
        this.loadingr = false;
      }).catch(err => {
        this.loadingr = false;
      })
    },

    // 我的考试列表
    getMySignRecord(){
      let params = {
        page:this.page,
        rows:this.rows,
        // status:this.type,
        // examType:this.cur,
        status:this.cur==2?'':this.type==0?'':this.type,
        signStatus:1
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      mySignRecord(params).then(res => {
        console.log('考试数据',res);
        // this.total = res.data.total;
        this.examItem = res.data.content;
        // loading.close();
      })
      // .catch(err => {
      //   loading.close();
      // })
    },
    onCur(e){
      this.type = e;
      this.examItem = [];
      this.getMySignRecord();
    },
    onButton(e){
      this.cur = e;
      this.getMySignRecord();
    },
    onExamPage(id,ifPractice){
      this.$confirm('开始考试后,切屏次数超过2次将自动交卷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path:'/exam/examPage', query: { id: id,ifPractice:ifPractice }})
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          offset:100
        });          
      });
     
    },
    examResult(id,ifPractice){
      this.signId = id;
      this.ifPractice = ifPractice
      this.getExamResult(id,ifPractice);
    },
    // 获取考试题目
    async getExamResult(id,ifPractice){
      let params = {
        signId:id,
        ifPractice:ifPractice
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await getExamResult(params).then(res => {
        console.log('考试答案',res);
        loading.close();
        if(res.code==0){
          this.dialogFormVisible = true;
          this.item = res.data;
          this.tableData[0].date = res.data.createTime;
          this.tableData[1].date = res.data.endTime;
          this.tableData[2].date = res.data.memberScore?res.data.memberScore:0; //分数
          this.tableData[3].date = res.data.passScore;
          this.tableData[4].date = res.data.status==0?'待审批':(res.data.status==1?'已通过':'未通过');
        }
      })
    },
    onAnalysis(){
      this.dialogFormVisible = false;
      this.$router.push({path:'/exam/analysis', query: { id: this.signId,ifPractice:1 }})
    },
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .nav-list{
    margin-top: 20px;
  }
  .nav-list ul{
    display: flex;
    align-items: center;
  }
  .nav-list ul li{
    font-size: 13px;
    padding: 10px 12px;
    /* margin:  0 10px; */
    cursor: pointer;
  }
  .divider{
    margin:  0 10px;
  }
  .nav-list ul .bar{
    color: #e1e2e6;
  }
  .nav-list ul .type{
    color: black;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c;
  }
  .enroll-list{
    /* margin-bottom: 50px; */
    margin-top: 32px;
  }
  .enroll-list ul li{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .enroll-list ul li .img{
    width: 270px;
    margin-right: 18px;
    /* height: 160px; */
  }
  .enroll-list ul li .img img{
    width: 270px;
    height: 155px;
    border-radius: 4px;
  }
  .enroll-list ul li .contetn{
    flex: 1;
  }
  .enroll-list ul li .contetn .contetn-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
  }
  .contetn-kv{
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    flex-wrap: wrap;
    border: 1px solid #e6e6e6;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
  }
  .contetn-kv .key{
    width: 32%;
    font-size: 13px;
    padding: 6px 0;
    background: url('../../assets/img/icon1.png') left center/10px 10px no-repeat;
    padding-left: 14px;
    color: #8f8f8f;
  }
  .contetn-kv .key span{
    font-size: 13px;
    color: black;
  }
  .enroll-list ul li .contetn .contetn-top .title{
    font-size: 15px;
    color: black;
    font-weight: 600;
    /* width: 200px; */
  }
  .enroll-list ul li .contetn .contetn-top .type{
    font-size: 10px;
    color: black;
    width: 54px;
    height: 20px;
    border-radius: 4px;
    background: #fff2e9;
    color: #f15903;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .types{
    font-size: 13px;
    width: 96px;
    height: 27.6px;
    border-radius: 4px;
    background: #fff2e9;
    color: #f15903;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
  .enroll-list ul li .contetn .contetn-top .time{
    font-size: 10px;
    color: #999;
    margin-left: 12px;
  }
  .el-button--small {
    padding: 7px 20px;
  }
 
  .buttons{
    color: #ff821c;
    border:1px solid #ff821c;
  }
  .buttons:hover{
    background: none;
  }

  .buttonss{
    color: #ff821c;
    border:1px solid #ff821c;
  }
  .buttonss:hover{
    /* background: none; */
    background: #ff821c;
    color: #fff;
    /* border: none; */
  }
  .el-pagination{
    text-align: center;
  }
  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 70px 110px 40px;
  }
  .popup-form-title{
  font-size: 14px;
  color: black;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.popup-form-title span{
  font-size: 15px;
  color: #f25902;
  margin-right: 2px;
}

.popup-form-coupon{
  margin-bottom: 20px;
}
.exam-contetn-text-radio /deep/ .ql-container {
  height: 200px;
}
.popup /deep/ .el-dialog{
  border-radius: 8px;
}
.popup /deep/ .el-dialog__header,.popup /deep/ .el-dialog__body{
  padding: 0;
}
.popup /deep/ .el-dialog__headerbtn .el-dialog__close{
  color: #fff;
  font-size: 19px;
  }
</style>


// WEBPACK FOOTER //
// src/views/exam/exam.vue